class ProductGallery extends HTMLElement {
  constructor() {
    super();
    this.observeSelectedVariantAttribute();
  }

  connectedCallback() {
    this.elements = {
      prevButton: this.querySelector('.prev-button'),
      nextButton: this.querySelector('.next-button'),
      dotsContainer: this.querySelector('.dots-container')

    };

    const loop = this.hasAttribute('data-loop');

    this.options = {
      axis: 'x',
      container: '[data-track]',
      slides: '[data-slide]',
      loop: loop,
    };

    this.option_thumbs_desktop = {
      axis: 'y',
      container: '[data-track]',
      slides: '[data-slide]',
      containScroll: 'keepSnaps',
      dragFree: true,
    };

    this.option_thumbs_mobile = {
      axis: 'x',
      container: '[data-track]',
      slides: '[data-slide]',
      containScroll: 'keepSnaps',
      dragFree: true,
    };

    this.viewportNodeMainCarousel = this.querySelector('.main-viewport');
    this.viewportNodeThumbCarouselDesktop = this.querySelector('.thumbnail-viewport-desktop');
    this.viewportNodeThumbCarouselMobile = this.querySelector('.thumbnail-viewport-mobile');


    this.init();
    this.setupDots();
    this.setupCalloutText();
    this.handleInitialVariantSelection();
  }

  observeSelectedVariantAttribute() {
    const closestElement = this.closest('[data-product-card-selected_variant_id]');
    if (!closestElement) return;

    const observer = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-product-card-selected_variant_id') {
          const newValue = closestElement.getAttribute('data-product-card-selected_variant_id');
          if (newValue) this.scrollToSlide(newValue);
        }
      }
    });

    observer.observe(closestElement, { attributes: true });
  }

  handleInitialVariantSelection() {
    const closestElement = this.closest('[data-product-card-selected_variant_id]');
    if (!closestElement) {
      console.warn("No ancestor element found with 'data-product-card-selected_variant_id' attribute for initial variant selection.");
      return;
    }

    const initialVariantId = closestElement.getAttribute('data-product-card-selected_variant_id');
    if (initialVariantId) {
      this.scrollToSlide(initialVariantId);
    }
  }
  
  scrollToSlide(selectedVariantId) {
    const targetSlideIndex = this.findSlideIndexByVariantId(selectedVariantId);
    if (targetSlideIndex !== -1) {
      this.emblaApiMain.scrollTo(targetSlideIndex, false);
      if (this.emblaApiThumb) {
        this.emblaApiThumb.scrollTo(targetSlideIndex, false);
      }
    }
  }

  findSlideIndexByVariantId(variantId) {
    return [...this.emblaApiMain.slideNodes()].findIndex(slide => slide.dataset.targetVariant === variantId);
  }

  init() {
    this.emblaApiMain = EmblaCarousel(this.viewportNodeMainCarousel, this.options);

    this.thumbApis = [];
    
    if (this.viewportNodeThumbCarouselDesktop) {
      this.emblaApiThumb = EmblaCarousel(this.viewportNodeThumbCarouselDesktop, { ...this.option_thumbs_desktop });
      this.thumbApis.push(this.emblaApiThumb);
    }

    if(this.viewportNodeThumbCarouselMobile) {
      this.emblaApiThumbMobile = EmblaCarousel(this.viewportNodeThumbCarouselMobile, { ...this.option_thumbs_mobile });
      this.thumbApis.push(this.emblaApiThumbMobile);
    }

    this.thumbApis.forEach(thumbApi => {
      const removeHandlers = [
        this.addThumbBtnsClickHandlers(thumbApi),
        this.addToggleThumbBtnsActive(thumbApi),
      ];
      thumbApi.on('destroy', () => removeHandlers.forEach(remove => remove()));
    });

    const removeHandlers = [
      this.addPrevNextBtnsClickHandlers(this.emblaApiMain, this.elements.prevButton, this.elements.nextButton),
    ];
    this.emblaApiMain.on('destroy', () => removeHandlers.forEach(remove => remove()));
  }

  addThumbBtnsClickHandlers(thumbApi) {
    const slidesThumbs = thumbApi.slideNodes();

    const scrollToIndex = slidesThumbs.map((_, index) => () => {
      this.emblaApiMain.scrollTo(index, false);
    });

    slidesThumbs.forEach((slideNode, index) => {
      slideNode.addEventListener('click', scrollToIndex[index], false);
    });

    return () => {
      slidesThumbs.forEach((slideNode, index) => {
        slideNode.removeEventListener('click', scrollToIndex[index], false);
      });
    };
  }

  addToggleThumbBtnsActive(thumbApi) {
    const slidesThumbs = thumbApi.slideNodes();

    const toggleThumbBtnsState = () => {
      const selected = this.emblaApiMain.selectedScrollSnap();
      const previous = this.emblaApiMain.previousScrollSnap();
      thumbApi.scrollTo(selected);
      slidesThumbs[previous]?.classList.remove('selected');
      slidesThumbs[selected]?.classList.add('selected');
    };

    this.emblaApiMain.on('select', toggleThumbBtnsState);
    thumbApi.on('init', toggleThumbBtnsState);

    return () => {
      slidesThumbs.forEach(slide => slide.classList.remove('selected'));
    };
  }

  addPrevNextBtnsClickHandlers(emblaApi, prevBtn, nextBtn) {
    const scrollPrev = () => emblaApi.scrollPrev();
    const scrollNext = () => emblaApi.scrollNext();

    if (prevBtn) {
      prevBtn.addEventListener('click', scrollPrev, false);
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', scrollNext, false);
    }

    const toggleState = () => {
      if (prevBtn) prevBtn.disabled = !emblaApi.canScrollPrev();
      if (nextBtn) nextBtn.disabled = !emblaApi.canScrollNext();
    };

    emblaApi.on('select', toggleState).on('init', toggleState);

    return () => {
      if (prevBtn) prevBtn.removeEventListener('click', scrollPrev, false);
      if (nextBtn) nextBtn.removeEventListener('click', scrollNext, false);
    };
  }


  setupDots() {
    console.log('setupDots');
    const dotsContainer = this.querySelector('.dots-container');
    if (!dotsContainer) return;

    const slideCount = this.emblaApiMain.slideNodes().length;

    for (let i = 0; i < slideCount; i++) {
      const dot = document.createElement('button');
      dot.className = 'dot';
      dot.addEventListener('click', () => {
        this.emblaApiMain.scrollTo(i);
      });
      dotsContainer.appendChild(dot);
    }

    const updateDots = () => {
      const selectedIndex = this.emblaApiMain.selectedScrollSnap();
      const dots = dotsContainer.querySelectorAll('.dot');
      dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === selectedIndex);
      });
    };

    this.emblaApiMain.on('select', updateDots).on('init', updateDots);
  }

  setupCalloutText() {
    const calloutText = this.querySelector('.callout-text');
    if (!calloutText) return;

    const toggleCalloutText = () => {
      calloutText.classList.toggle('is-hidden', this.emblaApiMain.selectedScrollSnap() !== 0);
    };

    this.emblaApiMain.on('select', toggleCalloutText).on('reInit', toggleCalloutText);
    toggleCalloutText();
  }
}

customElements.define('product-media-gallery', ProductGallery);